import { createSlice } from "@reduxjs/toolkit";

const saveSelectedProductToStorage = product => {
  if (product) {
    localStorage.setItem("selectedProduct", JSON.stringify(product));
  } else {
    localStorage.removeItem("selectedProduct");
  }
};

const initialState = {
  selectedMarketplaces: ["wb"],
  selectedFulfillments: ["fbo"],
  advertTypes: [],
  advertNames: [],
  selectedProduct: null,
  selectedWarehouses: [],
};

const innerProductCard = createSlice({
  name: "innerProductCard",
  initialState,
  reducers: {
    setSelectedMarketplaces: (state, action) => {
      state.selectedMarketplaces = action.payload;
    },
    setSelectedFulfillments: (state, action) => {
      state.selectedFulfillments = action.payload;
    },
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
      saveSelectedProductToStorage(action.payload);
    },
    setAdvertTypes: (state, action) => {
      state.advertTypes = action.payload;
    },
    setAdvertNames: (state, action) => {
      state.advertNames = action.payload;
    },
    setSelectedWarehouses: (state, action) => {
      state.selectedWarehouses = action.payload;
    },
  },
});

export default innerProductCard.reducer;

export const {
  setSelectedMarketplaces,
  setSelectedFulfillments,
  setSelectedProduct,
  setAdvertTypes,
  setAdvertNames,
  setSelectedWarehouses,
} = innerProductCard.actions;
